var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('b-button',{attrs:{"variant":"info"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarResponsaveisPadrao()}}},[_c('span',[_vm._v("Responsáveis Padrão")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }